import {
    apiRequest,
    acsosiokulturalList,
    acsosiokulturalActive,
    acsosiokulturalInactive
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", acsosiokulturalList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", acsosiokulturalInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", acsosiokulturalActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository